import type { SVGProps } from 'react';
const DawnFlagSI = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 22 16"
    {...props}
  >
    <path
      fill="#fff"
      d="M0 2a2 2 0 0 1 2-2h18a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2z"
    />
    <path
      fill="#F5F5F5"
      fillRule="evenodd"
      d="M20 .5H2A1.5 1.5 0 0 0 .5 2v12A1.5 1.5 0 0 0 2 15.5h18a1.5 1.5 0 0 0 1.5-1.5V2A1.5 1.5 0 0 0 20 .5M2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h18a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2z"
      clipRule="evenodd"
    />
    <mask
      id="dawn-flag-SI_svg__a"
      width={22}
      height={16}
      x={0}
      y={0}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: 'luminance',
      }}
    >
      <rect
        width={21.5}
        height={15.5}
        x={0.25}
        y={0.25}
        fill="#fff"
        stroke="#fff"
        strokeWidth={0.5}
        rx={1.75}
      />
    </mask>
    <g mask="url(#dawn-flag-SI_svg__a)">
      <path
        fill="#0C47B7"
        fillRule="evenodd"
        d="M0 10.667h22V5.333H7.263V4.267s-.739-.534-1.501-.534-1.572.534-1.572.534v1.066H0zM6.81 6.4c0 .59-.47 1.067-1.048 1.067A1.057 1.057 0 0 1 4.714 6.4c0-.589.47-1.067 1.048-1.067S6.81 5.811 6.81 6.4"
        clipRule="evenodd"
      />
      <g filter="url(#dawn-flag-SI_svg__b)">
        <path
          fill="#E53B35"
          fillRule="evenodd"
          d="M0 16h22v-5.333H0z"
          clipRule="evenodd"
        />
      </g>
    </g>
    <defs>
      <filter
        id="dawn-flag-SI_svg__b"
        width={22}
        height={5.333}
        x={0}
        y={10.667}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0" />
        <feBlend in2="BackgroundImageFix" result="effect1_dropShadow_88_1636" />
        <feBlend in="SourceGraphic" in2="effect1_dropShadow_88_1636" result="shape" />
      </filter>
    </defs>
  </svg>
);
export default DawnFlagSI;
